export default "__VITE_ASSET__k4iVshRr__"